import { NormalizeApi } from "../../normalizeApi";
const BASE_ZONES_ENDPOINT = 'base.rpc.tags-zones-v1';
const BASE_MOVING_ENDPOINT = 'base.rpc.tags-moving-v1';
export const TagZoneApi = NormalizeApi({
  list: `${BASE_ZONES_ENDPOINT}.index`,
  create: `${BASE_ZONES_ENDPOINT}.create`,
  view: `${BASE_ZONES_ENDPOINT}.view`,
  delete: `${BASE_ZONES_ENDPOINT}.delete`,
  update: `${BASE_ZONES_ENDPOINT}.update`,
  clearZones: `${BASE_MOVING_ENDPOINT}.clear-zones`
});